import React from "react"; 
import { 
  Dropdown, 
} from "react-bootstrap";  
import "../common/header/header.css"; 
import "../common/style.css";
import { 
  faPlusCircle, 
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; 
import 'moment-timezone'; 
import "bootstrap/dist/js/bootstrap"; 
import "bootstrap/dist/css/bootstrap.min.css"; 
import "bootstrap/js/src/dropdown"; 
import "../App.css";  
import _ from "lodash";  
import { useSelector } from "react-redux";
import { message } from "antd";

export default function DropdownItemsList({history}) {
  const accessContext = useSelector(state => state.UserContext.accessContext);
  const canView = (modulePermissions, moduleName) => {
    const vi= (modulePermissions || [])?.some(
      (item) => {
        if (moduleName == "Tasks"){
          return (
            item.module_name?.toLowerCase() === moduleName.toLowerCase() &&
            item.permissions?.View != "None"
          )
        } else {
          return(
        item.module_name?.toLowerCase() === moduleName.toLowerCase() &&
        item.permissions?.View == true
          )
        }
        }
    );
    return vi;
  };
  return (<Dropdown className="createnew create-actions">
                      <Dropdown.Toggle
                        id="dropdown-createnew"
                        className="createnew-drop"
                      >
                        <FontAwesomeIcon
                          className="fontawsome-text "
                          icon={faPlusCircle}
                        />
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="drop-menu-createnew">
                        <Dropdown.Item
                          // onClick={() => history.push({ pathname: '/app/project/create', state: { module: 'Deals', action: 'create' } })}
                          // onClick={() => { 
                          //   canView(accessContext?.modulePermissions, "Deals") ?
                          //   history.push({
                          //     pathname: "/dealcreate/Deals/create",
                          //     state: { module: "Deals", action: "create" },
                          //   }) : "";
                          // }}
                          onClick={() =>
                              canView(accessContext?.modulePermissions, "Deals") ? 
                            history.push({
                              pathname: "/dealcreate/Deals/create",
                              state: { module: "Deals", action: "create" },
                            }) : message.error("Permission Denied")
                            }
                          className ={!canView(accessContext?.modulePermissions, "Deals")  ? "nav-disabled" : ""}
                        >
                          Add Deal
                        </Dropdown.Item>
                        <Dropdown.Item
                          // onClick={() => history.push({ pathname: '/app/contact/createclient', state: { module: 'Accounts', action: 'create' } })}
                          onClick={() =>
                              canView(accessContext?.modulePermissions, "Accounts") ? 
                            history.push({
                              pathname: "/createclient/Accounts/create",
                              state: { module: "Accounts", action: "create" },
                            }) : message.error("Permission Denied")
                            }
                          className ={!canView(accessContext?.modulePermissions, "Deals")  ? "nav-disabled" : ""}
                        >
                          Add Account
                        </Dropdown.Item>
                        <Dropdown.Item
                          // onClick={() => history.push({ pathname: '/app/contacts/createVendor', state: { module: 'Vendors', action: 'create' } })}
                          onClick={() => 
                            canView(accessContext?.modulePermissions, "Vendor") ?
                            history.push({
                              pathname: "/vendorcreate/Vendors/create",
                              state: { module: "Vendors", action: "create" },
                            }) : message.error("Permission Denied")
                          }
                          className ={!canView(accessContext?.modulePermissions, "Deals")  ? "nav-disabled" : ""}
                        >
                          Add Vendor
                        </Dropdown.Item>
                        <Dropdown.Item
                        //    onClick={() => {
                        //     history.push(<PVSystemInformation />)
                        // }}
                        >
                          Add PV Module
                        </Dropdown.Item>
                        <Dropdown.Item>Add PV Manufacturer</Dropdown.Item>
                        <Dropdown.Item>Add String Inverters</Dropdown.Item>
                        <Dropdown.Item>Add Micro Inverters</Dropdown.Item>
                        <Dropdown.Item>Add General Contractors</Dropdown.Item>
                        <Dropdown.Item>Add Licensed Electricians</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>  )
}
